import { useCallback } from "react";
import { useFCIDetailsContext } from "./fci-details-context";
import type { LogArgs } from "./logFCI";
import { logFCI } from "./logFCI";

/**
 * Returns a `logFCI` wrapper that automatically merges the FCI context details
 * (formName, formType, etc.) into every call. Use inside React components/hooks
 * instead of importing `logFCI` directly.
 *
 * Call-site `details` override context values when keys collide.
 */
export const useLogFCI = () => {
    const contextDetails = useFCIDetailsContext();

    return useCallback(
        (args: LogArgs) => {
            logFCI({
                ...args,
                details: {
                    ...contextDetails,
                    ...args.details,
                },
            });
        },
        [contextDetails],
    );
};
